<template>
  <div class="live-commentary-menu-input-warp">
    <div
      v-if="!inputShow"
      class="overlay"
      :class="{'overlay-disabled': commentsDisabled}"
      @click="judgeAuthorityStatus"
    >
      <span v-if="commentsDisabled">Leave your comments about this match</span>
    </div>
    <div :class="['menu-input', { 'has-quote': showQuoteData }]">
      <!-- has quote -->
      <div
        v-if="showQuoteData"
        class="menu-input-quote"
      >
        <p>{{ quoteData.nickName }}</p>
        <p>{{ quoteData.commentaryText }}</p>
        <svg-icon
          icon-class="icon-clear"
          @click="clearQuoteData"
        />
      </div>

      <VInput
        ref="commentVInput"
        :value="commentInput"
        clearable
        placeholder="Leave your comments about this match"
        @input="onInput"
      />
    </div>

    <!-- nickname -->
    <VDialogBox
      v-model="nicknameVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <Nickname
        :visible="nicknameVisible"
        @onClose="closeNickname"
        @onSuccess="successNickname"
      />
    </VDialogBox>

    <!-- CommentsRules -->
    <VDialogBox
      v-model="commentsRulesVisible"
      :show-close="false"
      :show-footer="true"
      confirm-button-text="I Got It"
      :cancel-button-text="null"
      :close-on-click-modal="false"
      @close="closeCommentsRules"
    >
      <CommentsRules :visible="commentsRulesVisible" />
    </VDialogBox>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import { useUserStore } from '@ms/stores/user'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { useCommentsStore } from 'wap/stores/comments'
import { COMMENTS_NOT_AVAILABLE } from '@ms/config/message'
import VDialogBox from 'fe-vui/dialogBox'
import VInput from 'fe-vui/input'
import toast from 'fe-vui/toast'
import Nickname from 'wap/components/Nickname'
import CommentsRules from './CommentsRules'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/clear.svg'

export default {
  name: 'CommentaryInput',
  components: {
    Nickname,
    CommentsRules,
    VInput,
    VDialogBox
  },
  props: {
    inputShow: {
      type: Boolean,
      default: true
    },
    commentInput: {
      type: String,
      default: ''
    }
  },
  setup() {
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const user = useUserStore()
    const { phone, safePhone, nickname, showNickname } = storeToRefs(user)
    const commentsStore = useCommentsStore()
    const { userAuthority, quoteData, commentsDisabled } = storeToRefs(commentsStore)

    const { getUserCommentsAuthority, updateQuoteData } = commentsStore

    const matchDetailStore = useMatchDetailStore()
    const { event } = storeToRefs(matchDetailStore)

    return {
      loginStatus,
      phone,
      safePhone,
      nickname,
      showNickname,
      userAuthority,
      quoteData,
      commentsDisabled,
      getUserCommentsAuthority,
      updateQuoteData,
      event
    }
  },
  data() {
    return {
      nicknameVisible: false,
      commentsRulesVisible: false,
      quoteDataVisible: false
    }
  },
  computed: {
    onLive() {
      return this.event.status === 1 || this.event.status === 2
    },
    // 是否有资格评论 && 是否有引用评论 && 是否为input聚焦状态
    showQuoteData() {
      return this.quoteDataVisible && !!this.quoteData && this.inputShow
    }
  },
  watch: {
    loginStatus(val) {
      if (val) {
        this.getUserCommentsAuthority()
        useUserStore().getAccountInfo()
      }
    },
    quoteData(newV) {
      if (newV) {
        const judgeQuality = this.judgeAuthorityStatus()
        judgeQuality.then((res) => {
          if (res) {
            // 有资格 显示引用内容
            this.quoteDataVisible = true
          } else {
            // 无资格 隐藏并清空引用内容
            this.quoteDataVisible = false
            this.clearQuoteData()
          }
        })
      }
    }
  },
  methods: {
    onInput(val) {
      val = val.trim()
      this.$emit('changeInput', val)
    },
    nickphone() {
      const localphone = window.localStorage.getItem('m_sport_nick_phone') || ''
      if (localphone === this.phone) {
        return this.safePhone
      } else {
        return false
      }
    },
    async judgeAuthorityStatus() {
      if (this.commentsDisabled) {
        // 关闭评论
        toast(COMMENTS_NOT_AVAILABLE)
      } else if (!this.loginStatus) {
        // 登陆
        this.$login({
          onSuccess: () => {
            this.openInput()
          }
        })
      } else {
        if (this.userAuthority) {
          return this.judgeInputStatus()
        } else {
          await this.getUserCommentsAuthority()
          await useUserStore().getAccountInfo()
          return this.judgeInputStatus()
        }
      }
    },
    judgeInputStatus() {
      // connments 关闭 登陆 赛中 评论资质 封禁 nickname 首次评论
      // console.log('Input =>', this.commentsDisabled, this.loginStatus, this.event.status, this.userAuthority)
      const isFirstComment = this.userAuthority.firstComments && !window.localStorage.getItem('m_sport_comment_first')
      const nickname = this.nickname || this.nickphone()
      if (!this.onLive) {
        // live
        this.$dialog({
          title: 'Note',
          message: COMMENTS_NOT_AVAILABLE,
          confirmButtonText: 'OK',
          cancelButtonText: null
        }).catch(console.log)
      } else if (!this.userAuthority.hasQuality) {
        // hasQuality
        this.$dialog({
          title: 'Note',
          message:
            'In order to have a better environment of comments, comments function are only avaliable to MSport customers who has done at least one bet. Finish your first bet and join the comments now!',
          confirmButtonText: 'OK',
          cancelButtonText: null
        }).catch(console.log)
      } else if (this.userAuthority.hasBlocked) {
        // hasBlocked
        this.$dialog({
          title: 'Note',
          message: 'Due to certain violation of commenting rules on the platform, your Comment function has been blocked. If you have any question, please contact the Customer Service.',
          confirmButtonText: 'OK',
          cancelButtonText: 'Check Rules'
        })
          .catch(() => {
            this.openCommentsRules()
          })
      } else if (!nickname) {
        this.nicknameVisible = true
        modalHelper.afterOpen()
      } else if (isFirstComment) {
        // 首次评论
        this.openCommentsRules()
      } else {
        this.openInput()
        // 有评论资格
        return true
      }
    },
    openInput() {
      console.log('openInput')
      this.$refs.commentVInput.handleFocus()
      this.$emit('changeInputShow', true)
    },
    closeNickname() {
      modalHelper.beforeClose()
      this.nicknameVisible = false
      this.$dialog({
        title: 'Note :',
        message: `Your temporary nickname is ${this.safePhone}, you can go to the [ME] page to modify it at any time.`,
        confirmButtonText: 'OK',
        cancelButtonText: null
      })
        .then(() => {
          window.localStorage.setItem('m_sport_nick_phone', this.phone)
        })
        .catch(console.log)
    },
    successNickname() {
      modalHelper.beforeClose()
      this.nicknameVisible = false
      useUserStore().getAccountInfoWrap()
    },
    openCommentsRules() {
      this.commentsRulesVisible = true
      modalHelper.afterOpen()
    },
    closeCommentsRules() {
      modalHelper.beforeClose()
      this.commentsRulesVisible = false
      window.localStorage.setItem('m_sport_comment_first', 1)
    },
    // 清空引用内容
    clearQuoteData() {
      this.updateQuoteData(null)
    }
  }
}
</script>
